module.exports = __webpack_public_path__ + "static/star-e3342aec282f7270fa6200d9c7a9e7a3.mp4";